export default "assets/images/icons/scroll-down-57552d4b.svg";